module.exports = __webpack_public_path__ + "img/AstroFrens116.53b92740.jpg";